import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { SectionGroup } from 'Components/Layout';
import { WorksheetRootComponent } from '../Core';
import ids from '../QestIds';
import AsLinearShrinkageDryingSection from './AS/Sections/DryingSection';
import AsLinearShrinkageEquipmentSection from './AS/Sections/EquipmentSection';
import AsLinearShrinkageMeasurementsSection from './AS/Sections/MeasurementsSection';
import AsLinearShrinkageResultsSection from './AS/Sections/ResultsSection';
import AsLinearShrinkageSampleMassSection from './AS/Sections/SampleMassSection';
import { AsLinearShrinkageTestForMCSectionMeasured } from './AS/Sections/TestForMoistureConditionSectionMeasured';

let MeasuredLinearShrinkageWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <SectionGroup heading="Sample Mass">
        <AsLinearShrinkageSampleMassSection />
      </SectionGroup>
      <AsLinearShrinkageTestForMCSectionMeasured />
      <AsLinearShrinkageEquipmentSection />
      <AsLinearShrinkageDryingSection />
      <AsLinearShrinkageMeasurementsSection />
      <AsLinearShrinkageResultsSection />
    </>
  );
};

MeasuredLinearShrinkageWorksheet.qestIds = [ids.linearShrinkage.AS_1289_5_4_1.rev2008];
MeasuredLinearShrinkageWorksheet = withInjectedProps(MeasuredLinearShrinkageWorksheet);

export { MeasuredLinearShrinkageWorksheet };
export default MeasuredLinearShrinkageWorksheet;
